// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media all and (min-height: 650px){.login-page-box{margin-top:50px}}\n", ""]);
// Exports
module.exports = exports;
